import styled, { css } from 'styled-components';
import { variant } from 'styled-system';

const Wrapper = styled.div(({ theme: { colors, radii, fonts, fontSizes, fontWeights, shadows } }) => css `
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    text-align: left;

    padding: 8px;
    border-radius: ${radii.xxlarge};

    font-family: ${fonts.primary};
    font-size: ${fontSizes.E};
    font-weight: ${fontWeights.regular};

    box-shadow: ${shadows.boxShadow.outer};

    ${() => variant({
    prop: 'variant',
    variants: {
        default: {
            color: colors.foreground.secondary.B,
            backgroundColor: colors.background.secondary.A,
            border: `1px solid ${colors.border.A}`,
        },
        negative: {
            color: colors.foreground.primary.A,
            backgroundColor: colors.state.negative.A,
        },
        positive: {
            color: colors.foreground.primary.A,
            backgroundColor: colors.state.positive.A,
        },
    },
})}

    a,
    .link {
      color: inherit;
      text-decoration: underline;
    }

    a:hover,
    .link:hover {
      color: inherit;
    }
  `);
const ChildrenWrapper = styled.div `
  padding-left: 12px;
  white-space: pre-wrap;
`;
const CloseWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;

  width: 40px;
  height: 32px;

  cursor: pointer;
`;

export { ChildrenWrapper, CloseWrapper, Wrapper };
